import { logger } from '@common/logger';

/**
 * Fetch with error logging for non-HTTP errors.
 */
export const getFetchWithErrorLogging = (fetchFn: typeof fetch): typeof fetch => {
    return async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
        try {
            return await fetchFn(input, init);
        } catch (err) {
            let url = '';

            if (typeof input === 'string') {
                url = input;
            } else if (input instanceof URL) {
                url = input.toString();
            } else {
                url = input.url;
            }

            const msg = typeof err === 'object' && err !== null && 'message' in err ? err.message : '';

            logger.error(`Fetch failed for "${url}" with message "${msg}"`);

            throw err;
        }
    };
};
